<template>
    <div>
        <div class="tabs is-centered is-toggle is-medium mt-3">
            <ul>
                <li :class="{ 'is-active': active === 'base' }">
                    <a @click="active = 'base'">
                        <span>BASE</span>
                    </a>
                </li>
                <li :class="{ 'is-active': active === 'interval' }">
                    <a @click="active = 'interval'">
                        <span>INTERVALOS</span>
                    </a>
                </li>
            </ul>
        </div>
        <div v-show="active === 'base'">
            <BaseReport />
        </div>
        <div v-show="active === 'interval'">
            <IntervalReport />
        </div>
    </div>
</template>

<script>
import BaseReport from "./base/BaseReport.vue";
import IntervalReport from "./interval/IntervalReport.vue";

export default {
    name: "reports",
    components: {
        BaseReport,
        IntervalReport,
    },
    data() {
        return {
            active: "base",
        };
    },
};
</script>